import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const LOGIN_VALIDATION_SCHEMA = yup.object().shape({
  // Polje prima korisničko ime ili email, pa se format emaila ne provjerava.
  email: yup
    .string()
    .typeError(IGNORE_ERROR)
    .trim()
    .required("Molimo Vas da unesete korisničko ime ili email"),
  password: yup.string().required("Molimo Vas da unesete ispravnu lozinku"),
});
